import { getSeverityVariant } from '@/lib/utils';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

interface ScoreBreakdownProps {
    wallet: number;
    size: number;
    timing: number;
    priceEdge: number;
    total: number;
}

export function ScoreBreakdown({ wallet, size, timing, priceEdge, total }: ScoreBreakdownProps) {
    const items = [
        { label: 'Wallet', value: wallet, max: 40, color: 'from-blue-500 to-blue-400' },
        { label: 'Size', value: size, max: 25, color: 'from-purple-500 to-purple-400' },
        { label: 'Timing', value: timing, max: 20, color: 'from-orange-500 to-orange-400' },
        { label: 'Price Edge', value: priceEdge, max: 15, color: 'from-cyan-500 to-cyan-400' },
    ];

    return (
        <Card>
            <CardHeader className="flex flex-row items-center justify-between">
                <CardTitle>Score Breakdown</CardTitle>
                <Badge variant={getSeverityVariant(total)} className="font-mono text-base px-3 py-1">
                    {total}/100
                </Badge>
            </CardHeader>
            <CardContent className="space-y-4">
                {items.map((item) => (
                    <div key={item.label} className="space-y-2">
                        <div className="flex items-center justify-between text-sm">
                            <span className="text-muted-foreground">{item.label}</span>
                            <span className="font-mono font-medium">
                                {item.value}/{item.max}
                            </span>
                        </div>
                        <div className="h-2 bg-muted rounded-full overflow-hidden">
                            <div
                                className={`h-full bg-gradient-to-r ${item.color} rounded-full transition-all duration-500`}
                                style={{ width: `${(item.value / item.max) * 100}%` }}
                            />
                        </div>
                    </div>
                ))}
            </CardContent>
        </Card>
    );
}
